import "core-js/modules/es.object.keys.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-05f0b634"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "triangle"
  }, null, -1);
});

var _hoisted_2 = {
  "class": "emoji-content"
};
var _hoisted_3 = {
  "class": "category"
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  "class": "next-page"
};
var _hoisted_6 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    "class": "emoji-selector",
    onMousedown: [_cache[0] || (_cache[0] = _withModifiers(function () {}, ["prevent"])), _cache[1] || (_cache[1] = _withModifiers(function () {}, ["stop"]))]
  }, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.currentEmojis, function (item, i) {
    return _openBlock(), _createElementBlock("div", {
      key: "emoji-".concat(i),
      "class": "item",
      onClick: function onClick($event) {
        return _ctx.$emit('choose', item);
      }
    }, _toDisplayString(item), 9, _hoisted_4);
  }), 128))])]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys($data.emojis), function (cat) {
    return _openBlock(), _createElementBlock("div", {
      key: cat,
      "class": _normalizeClass({
        active: $data.currentCat === cat
      }),
      onClick: function onClick($event) {
        return $data.currentCat = cat;
      }
    }, null, 10, _hoisted_6);
  }), 128))])], 32);
}